import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@primer/components';
import useQRCode from 'uikit/hooks/useQRCode/useQRCode';
import { getQRCode } from 'pages/CustomQRCodes/utils';
import { Button } from 'uikit/buttons/Button/Button';
import InstallAppContinueLink from './InstallAppContinueLink';
import {
    CONTINUE_BUTTON_LABELS,
    DEFAULT_QR_CODE_SIZE,
    DOWNLOAD_APP_HEADINGS,
    GUEST_LOGIN_STEPS,
    GUEST_LOGIN_SUBHEADING,
} from './downloadAppDesktopConstants';
import './DownloadAppDesktopPreview.scss';

const DownloadAppDesktopPreview = ({
    qrCodeUrl,
    hasRedirectUrl = false,
    qrCodeSize = DEFAULT_QR_CODE_SIZE,
    showDefaultHeading = true,
    showGuestSteps = true,
    contentBelowQr = null,
    onContinue,
    continueButtonText = CONTINUE_BUTTON_LABELS.BROWSER,
    continueButtonClass = 'continue-in-browser-button',
    continueAsLink = false,
    contentClassName = 'download-app-content',
}) => {
    const [qrCode, setQRCode] = useState('');

    const heading = useMemo(
        () =>
            hasRedirectUrl
                ? DOWNLOAD_APP_HEADINGS.CONTINUE_ON_APP
                : DOWNLOAD_APP_HEADINGS.DOWNLOAD,
        [hasRedirectUrl]
    );

    const { PreviewQRCode } = useQRCode({
        qrCodes: [
            {
                value: qrCodeUrl,
                title: 'qr code',
            },
        ],
        qrCodeForDisplay: qrCode,
        size: qrCodeSize,
        isDisableDownload: true,
    });

    useEffect(() => {
        if (!qrCodeUrl) {
            setQRCode('');
            return;
        }
        getQRCode(qrCodeUrl, setQRCode);
    }, [qrCodeUrl]);

    return (
        <Box className={contentClassName}>
            {qrCode && (
                <Box className="download-app-qr">{PreviewQRCode}</Box>
            )}
            {showDefaultHeading && (
                <Box as="h1" className="download-app-heading">
                    {heading}
                </Box>
            )}
            {contentBelowQr}
            {showGuestSteps && (
                <>
                    <Box as="h2" className="guest-login-subheading">
                        {GUEST_LOGIN_SUBHEADING}
                    </Box>
                    <Box as="ol" className="guest-login-steps">
                        {GUEST_LOGIN_STEPS.map((step, index) => (
                            <Box as="li" key={step} className="guest-login-step">
                                <span className="guest-login-step-number">
                                    {index + 1}
                                </span>
                                <span className="guest-login-step-text">
                                    {step}
                                </span>
                            </Box>
                        ))}
                    </Box>
                </>
            )}
            {onContinue && (
                <>
                    <Box className="or-divider" aria-hidden="true">
                        <span>Or</span>
                    </Box>
                    {continueAsLink ? (
                        <InstallAppContinueLink
                            label={continueButtonText}
                            onClick={onContinue}
                        />
                    ) : (
                        <Button
                            onClick={onContinue}
                            variant="primary"
                            buttonClass={continueButtonClass}
                        >
                            {continueButtonText}
                        </Button>
                    )}
                </>
            )}
        </Box>
    );
};

export default DownloadAppDesktopPreview;
